{
	"title": "Projects",
	"table": {
		"reference": "Reference",
		"quantity": "Total quantity",
		"savings": "Total carbon reductions",
		"fetchError": "Could not fetch projects"
	},
	"showProjectsHistoryTitle": "Show projects history",
	"noProjects": {
		"createDeclaration": "Create your first declaration",
		"description": "You can create declarations for one or more materials by clicking on “Create declaration”."
	}
}
